import React from 'react';
import EditUser from '../../App/Usuários/Edit';

export default function Usuarios_Editar () {
  return <EditUser />
}
